import { PRODUCTS } from './urls';

export const getProduct = (web_id) => {
  return fetch(`${PRODUCTS}/${web_id}`)
};